import { Stack, IconButton } from "@mui/material";
import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownOutlinedIcon from "@mui/icons-material/ThumbDownOutlined";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import React, { useEffect, useState } from "react";
import { rateMessage, retryMessage } from "../../../apis/copilot/copilot";
import { useCopilotStore } from "../../../store/copilot/CopilotStore";
import { LightTooltip } from "../../LightTooltip";
import RefreshIcon from "@mui/icons-material/Refresh";
import { Rate, RateType } from "../../../apis/copilot/types";

interface Props {
  messageId: string;
  rate: Rate | null;
  showRetry: boolean;
}

export const Actions: React.FC<Props> = ({ messageId, rate, showRetry }) => {
  const threadId = useCopilotStore((state) => state.threadId) as string;
  const messages = useCopilotStore((state) => state.messages);
  const setMessages = useCopilotStore((state) => state.setMessages);
  const setIsLoading = useCopilotStore((state) => state.setIsLoading);

  const [rateValue, setRateValue] = useState<number | null>(
    rate?.rate_value || null
  );

  useEffect(() => {
    if (rateValue !== (rate?.rate_value || null)) {
      rateMessage(threadId, messageId, RateType.BOOLEAN, rateValue);
    }
  }, [rateValue, rate?.rate_value, threadId, messageId]);

  const handleOnThumbsUp = () => {
    setRateValue(rateValue === 1 ? null : 1);
  };

  const handleOnThumbDown = () => {
    setRateValue(rateValue === 0 ? null : 0);
  };

  const handleOnRetry = async () => {
    const currentMessages = messages.filter((m) => m.id !== messageId);
    setMessages(currentMessages);
    setIsLoading(true);
    const newMessages = await retryMessage(threadId, messageId);
    setIsLoading(false);
    setMessages([...currentMessages, ...newMessages]);
  };

  return (
    <Stack flexDirection="row" justifyContent="end">
      <IconButton color="secondary" size="small" onClick={handleOnThumbsUp}>
        {rateValue === 1 ? (
          <ThumbUpIcon fontSize="small" />
        ) : (
          <ThumbUpOutlinedIcon fontSize="small" />
        )}
      </IconButton>

      <IconButton color="secondary" size="small" onClick={handleOnThumbDown}>
        {rateValue === 0 ? (
          <ThumbDownIcon fontSize="small" />
        ) : (
          <ThumbDownOutlinedIcon fontSize="small" />
        )}
      </IconButton>

      {showRetry && (
        <LightTooltip title="Try Again">
          <span>
            <IconButton color="secondary" onClick={handleOnRetry}>
              <RefreshIcon />
            </IconButton>
          </span>
        </LightTooltip>
      )}
    </Stack>
  );
};
